export default __webpack_public_path__ + "static/media/mvoult-icon-dark.acf957fb.png";